module.exports = __webpack_public_path__ + "static/img/3.30a6a1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/3.png
// module id = JYwY
// module chunks = 0